import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Flex, Spin } from 'antd';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { user, loading, hasPermission } = useAuth();
  const location = useLocation();
  const { lang } = useParams();

  if (loading) {
    return (
      <Flex
        justify="center"
        align="center"
        style={{ minHeight: '100vh' }}
      >
        <Spin size="large" />
      </Flex>
    );
  }

  if (!user) {
    console.warn('[Bidmanager ProtectedRoute] redirecting to /login (no user)', {
      pathname: location.pathname,
      search: location.search,
      href: typeof window !== 'undefined' ? window.location.href : '',
    });
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to={`/${lang || 'en'}/dashboard`} replace />;
  }

  return children;
};

export default ProtectedRoute;
